module.exports = __webpack_public_path__ + "img/stick_hebergements_gite_etape.9881b14f.svg";